import { handleApiError } from "../@api/apiError";

export async function getJsonResponse(response: Response) {
  if (response.ok) {
    return await response.json();
  } else {
    return await handleApiError(response);
  }
}

export async function getNoContentResponse(response: Response) {
  if (response.status === 204) {
    return response.status;
  } else {
    return await handleApiError(response);
  }
}
